import CheckBoxMultiCheck from "../../../../Sections/ElementsSections/CheckBoxMultiCheck";
import dialogStyles from "../dialogStyles.module.css";

export default function DayTypeCheckBox({ label, checkValues, onEditCheckBox }) {
  return (
    <div className={dialogStyles.dialogDayTypeCheckBoxContainer}>
      <div>
        <CheckBoxMultiCheck onEdit={onEditCheckBox} parentProps={{ name: label }} CheckState={checkValues[label]} />
      </div>
      <div className={dialogStyles.dialogDayTypelabel}>{label}</div>
    </div>
  );
}
